/* Angular Pre-Defined Components */
import './../theme/theme.scss'
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';

/** MSAL Configurations */
import { MsalModule, MsalGuard, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalInterceptorConfiguration, MsalService, MsalGuardConfiguration, MSAL_GUARD_CONFIG, MsalBroadcastService } from '@azure/msal-angular';
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { msalConfig } from './core/guards/msal-config';
import { TokenInterceptor } from './core/interceptors/token.interceptor';

/** user defined components */
import { DashboardComponent } from './dashboard/dashboard.component';
import { CostaComponent } from './costa/costa.component';
import { NavigationBarComponent } from './shared/navigation-bar/navigation-bar.component';
import { DashboardCardComponent } from './dashboard-card/dashboard-card.component';
import { environment } from '../environments/environment';

/** Third Party Components */
import { SidebarModule } from 'primeng/sidebar';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ToastrModule } from 'ngx-toastr';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxUiLoaderConfig, NgxUiLoaderHttpModule, NgxUiLoaderModule, PB_DIRECTION, POSITION, SPINNER } from 'ngx-ui-loader';
import { DBConfig, NgxIndexedDBModule } from 'ngx-indexed-db';

import * as constant from './shared/constants/constants';
import { NotificationMenuComponent } from './notification-menu/notification-menu.component';
import * as apiUrl from '../app/shared/constants/api-urls';
import {navigationPermission } from './shared/guards/navigation.guard';
import {MsalRedirectComponent} from "@azure/msal-angular";
import { SharedModule } from './modules/shared/shared.module';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  pbColor: "$primary-costa-color",
  fgsColor: '$primary-costa-color',
  fgsPosition: POSITION.centerCenter,
  fgsSize: 0,
  fgsType: SPINNER.squareJellyBox,
  pbDirection: PB_DIRECTION.leftToRight,
  pbThickness: 5,
  logoPosition: "center-center",
  logoSize: 80,
  logoUrl: `assets/images/logo/hot-coffee.gif`,
};

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;


const dbConfig: DBConfig = {
  name: constant.common.indexed_db_name,
  version: 1,
  objectStoresMeta: [{
    store: constant.common.indexed_db_store,
    storeConfig: { keyPath: 'config_key', autoIncrement: false },
    storeSchema: [
      { name: 'Config Key', keypath: 'config_key', options: { unique: true } },
      { name: 'Config Value', keypath: 'config_value', options: { unique: false } }
    ]
  }]
};

export function loggerCallback(logLevel: LogLevel, message: string) {
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: msalConfig.auth.clientId,
      authority: msalConfig.auth.authority,
      redirectUri: msalConfig.auth.redirectUri
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, any>();
  protectedResourceMap.set(environment.API_ENDPOINT, ['user.read']);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [environment.AUDIANCE]
    }
  };
}

@NgModule({
  declarations: [
    AppComponent,
    NavigationBarComponent,
    DashboardComponent,
    CostaComponent,
    DashboardCardComponent,
    NotificationMenuComponent
  ],
  imports: [
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SidebarModule,
    ScrollPanelModule,
    PanelMenuModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-center',
      preventDuplicates: true,
    }),
    MsalModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderHttpModule.forRoot({
      showForeground: true,
      exclude: [],
      excludeRegexp:[apiUrl.dashboard.getNotificationStatus]
    }),
    NgxIndexedDBModule.forRoot(dbConfig)
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    navigationPermission
  ],
  bootstrap: [AppComponent,MsalRedirectComponent]
})
export class AppModule { }
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
